import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { CodeIcon, PencilIcon, DotsVerticalIcon } from "@heroicons/react/solid";
import InputMask from "react-input-mask";
import NeatcarButton from "../../components/NeatcarButton";
import Paginator from "../../components/Paginator";
import TransactionRow from "../../components/TransactionRow";
import LoadingIndicator from "../../components/LoadingIndicator";
//import visa from '../../assets/images/visa.png';
//import mastercard from '../../assets/images/mastercard.png';
import { getCurrentCard, setCreditCardLoading } from "../../store/actions/Business";
import { updateCard } from "../../services/business";
import { pushNotification } from "../../store/actions/Notifications";
import { ERROR, Notification, SUCCESS } from "../../models/Notification";
import { getCSV } from "../../services/transactions";
import fileDownload from 'js-file-download';
import { RoutesTable } from "../../table/routes/RoutesTable"
import { Store, columns } from "../../table/routes/columns"

import { getStoresData, getRemainingCarwashData, getCarwashTypeData, modifyAmountBuying } from 'store/actions/Support';

const RoutesPage = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [page, setPage] = useState(1);
  const [csvLoading, setCsvLoading] = useState(false);
  const { t } = useTranslation(['billing', 'transaction']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stores = useSelector(store => store.support);
  const [tableData, setTableData] = useState([]);


  const [data, setData] = useState([]);
  const storeRouteSeparated = [];

  useEffect(() => {
    async function fetchData() {
      const fetchedData = await getData();
      setData(fetchedData);
      console.log(data)
    }
    fetchData();
  }, []);

  useEffect(() => {

    dispatch(getStoresData());


  }, [dispatch, navigate, page]);



  useEffect(() => {
    if (stores && stores.storesLoading === false) {
      stores.stores.map(store => {
        store.routes.forEach(route => {
          const duplicatedObject = { ...store,
             routes: [route],
             associatedRoute: store.routes ,


             ///////////i was here
             //currentlyBuying: stores.currentBuying.find(object => object.storeId == row.original.id && object.routeName == table.getColumn('routes')?.getFilterValue())?.amountBuying || 0
};
          storeRouteSeparated.push(duplicatedObject);
        });
      });
      console.log(storeRouteSeparated);
      setTableData(storeRouteSeparated);
      console.log(stores.stores);
    }
  }, [stores]);

 



  useEffect(() => {
    dispatch(getCurrentCard());
  }, [dispatch]);

  const onSubmit = (data) => {
    dispatch(setCreditCardLoading(true));
    updateCard({
      name: data.name,
      number: data.cardNumber.replace(/\s/g, ''),
      exp_month: data.expirationDate.substring(0, 2),
      exp_year: `20${data.expirationDate.substring(3, 5)}`,
      cvv: data.cvv
    }).subscribe({
      next: () => {
        dispatch(getCurrentCard());
        dispatch(pushNotification(new Notification(SUCCESS, t('billing:modifiedCreditCardSuccessTitle'), t('billing:modifiedCreditCardSuccessMessage'))));
      },
      error: (err) => {
        dispatch(setCreditCardLoading(false));
        dispatch(pushNotification(new Notification(ERROR, t('billing:modifiedCreditCardErrorTitle'), t('billing:modifiedCreditCardErrorMessage'))));
      }
    });
  }

  async function getData() {
    // Fetch data from your API here.
    return [
      {
        id: '728ed52f',
        amount: 100,
        status: 'pending',
        email: 'm@example.com',
      },
      // ...
    ];
  }




  return (
    <div className="flex-1 flex-row gap-x-8">





      <RoutesTable columns={columns(stores, dispatch)} data={tableData} />


    </div>
  )
};

export default RoutesPage;
